angular.module('vehicle-location', ['core'])
    .constant('VehicleLocationConst', {
        eventUpdate: 'vehicle-location.updated',
        tpl: 'app/vehicle-location/'
    })
    .factory('VehicleLocation', function ($resource) {
        return $resource('crm/api/vehicle-location/:id', {id: '@id'}, {
            table: {method: 'GET', url: 'crm/api/vehicle-location/table', isArray: false},
            update: {method: 'PUT'},
            myLocations: {method: 'GET', url: 'crm/api/vehicle-location/my-locations', isArray: true},
        })
    })
    .service('VehicleLocationService', function (modals, $rootScope, VehicleLocation, VehicleLocationConst) {
        this.add = params => {
            let entity = {
                id: null
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.myLocations = () => {
            return VehicleLocation.myLocations().$promise;
        }
        this.edit = entity => {
            modals.open(VehicleLocationConst.tpl + 'edit-modal.html', 'VehicleLocationEditController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.delete = entity => {
            return modals.confirmDelete("wybrany rekord", () => VehicleLocation.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(VehicleLocationConst.eventUpdate)));
        }
    })
    .controller('VehicleLocationEditController', function (toastr, $scope, $rootScope, $uibModalInstance, VehicleLocation, VehicleLocationConst, data, VehicleLocationService) {
        this.VehicleLocationService = VehicleLocationService
        this.$onInit = () => {
            this.item = data
            VehicleLocation.get({id: this.item.id}).$promise.then(result => this.item = result)
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = VehicleLocation.update(this.item).$promise
            } else {
                promise = VehicleLocation.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(VehicleLocationConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .component('vehicleLocationList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/vehicle-location/list.html',
        controller: function ($scope, $state, $stateParams, VehicleLocation, VehicleLocationService, VehicleLocationConst) {
            this.VehicleLocationService = VehicleLocationService
            this.reset = () => this.filters = {}
            $scope.$on(VehicleLocationConst.eventUpdate, () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider
            .state('vehicleLocationList', {
                parent: 'app',
                url: '/vehicle-location?{page:int}&{size:int}&{sort:string}&{search:string}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_VEHICLE_LOCATION_MANAGEMENT'],
                },
                views: {
                    'content@': 'vehicleLocationList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (VehicleLocation, $stateParams) => VehicleLocation.table(angular.copy($stateParams)).$promise
                        .then(result => {
                            result.list.forEach(item => {
                                let cityPostcode = [item.postcode, item.city].filter(x => x).join(" ");
                                item.fullAddress = [item.address, cityPostcode].filter(x => x).join(", ");
                            })
                            return result
                        })
                }
            })
    })
